import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { authenticatedUser, unauthenticatedUser, userAttributes } from '../auth/redux-utils/reducers';
import { standardErrorReducer } from './redux-utils/reducers';

export const authReducers = combineReducers({
  authenticatedUser,
  unauthenticatedUser,
  userAttributes,
  errors: standardErrorReducer,
  form: formReducer
});
